import React, {useEffect, useState}					from 'react';
import moment										from 'moment';
import {Route, Routes, useParams}					from 'react-router-dom';
import {QRCodeSVG}									from 'qrcode.react';

import SettingsAddress								from './SettingsAddress';
import Header										from '../Header/Header';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import Input										from '../ressources/components/Input';
import Button										from '../ressources/components/Button';
import ProfilePicture								from '../ressources/components/Avatar/ProfilePicture';
import Select										from '../ressources/components/Select';
import ButtonStickyContainer						from '../ressources/components/Button/ButtonStickyContainer';
import DocumentItem									from '../ressources/components/Document';
import Tabs											from '../ressources/components/Tabs';
import Icon											from '../ressources/components/Icon';
import Badge										from '../ressources/components/Badge';
import Modal										from '../ressources/components/Modal';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {InputValues}								from '../ressources/components/Input/interface';
import {PutUserData}								from '../redux/companyUsers/interface';
import {PutCompanyData} 							from '../redux/company/interface';
import {SelectValues}								from '../ressources/components/Select/interface';
import {putCompanyUsersApi,
	uploadProfilePictureApi}						from '../redux/companyUsers/companyUsers';
import {putCompanyApi}								from '../redux/company/company';
import {changeUserSettings, changeUserProfilePicture,
	setUserMFA}										from '../redux/user/user';
import {TabsData}									from '../ressources/components/Tabs/interface';
import {Document} 									from '../redux/documents/interface';
import {pushUpload, setUploadPercent}				from '../redux/documents/documents';
import {LanguageType}								from '../ressources/language/type';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import {ft_formatAddressInline}						from '../ressources/functions/format';
import {ft_checkRight}								from '../ressources/functions/userFunction';
import {ft_getDocumentCreator}						from '../ressources/functions/document';

import {regex_password}								from '../ressources/data/regex';

import img_settings									from '../ressources/images/icon/menu/settings.svg';
import img_alert									from '../ressources/images/icon/alert-circle.svg';
import img_upload									from '../ressources/images/icon/upload.svg';
import img_trash									from '../ressources/images/icon/trash.svg';

import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './Settings.css';


function Settings() {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);
	const company = useAppSelector(state => state.company.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const address = useAppSelector(state => state.address.data);
	const documentsUpload = useAppSelector(state => state.documents.uploadDocument);
	const notificationId = useAppSelector(state => state.notifications.lastId);

	const [load, set_load] = useState(false);
	const [modal, set_modal] = useState<boolean | string>(false);
	const [modalDocument, set_modalDocument] = useState<null | {url: string, document: Document}>(null);
	const [modalUpload, set_modalUpload] = useState<null | File>(null);

	const [firstname, set_firstname] = useState<InputValues>('');
	const [lastname, set_lastname] = useState<InputValues>('');
	const [email, set_email] = useState<InputValues>('');
	const [phone, set_phone] = useState<InputValues>('');
	const [contractStart, set_contractStart] = useState<InputValues>('');
	const [contractEnd, set_contractEnd] = useState<InputValues>('');
	const [job, set_job] = useState<InputValues>('');
	const [profilePictureFile, set_profilePictureFile] = useState<File | undefined>(undefined);
	const [profilePictureImg, set_profilePictureImg] = useState<string | undefined>(undefined);

	const [password, set_password] = useState<InputValues>('');
	const [newPassword, set_newPassword] = useState<InputValues>('');
	const [newPasswordConfirm, set_newPasswordConfirm] = useState<InputValues>('');
	const [mfaSecret, set_mfaSecret] = useState('');
	const [mfaKey, set_mfaKey] = useState<InputValues>('');

	const [name, set_name] = useState<InputValues>('');
	const [siret, set_siret] = useState<InputValues>('');
	const [documents, set_documents] = useState<Document[]>([]);
	const [documentsView, set_documentsView] = useState<keyof LanguageType['settings']['documentsType']>('companyBalance');

	const [mainAddress, set_mainAddress] = useState<string | React.ReactElement>('');
	const [mainBillingAddress, set_mainBillingAddress] = useState<string | React.ReactElement>('');
	const [documentDate, set_documentDate] = useState<InputValues>('');

	const [addressMenu, set_addressMenu] = useState<SelectValues>('main');
	const [change, set_change] = useState(false);

	const TEXTE = LANGUAGE(lang);
	const params = useParams();

	let findMissing = false;

	const DOCUMENTS_MENU: TabsData[] = Object.entries(TEXTE.settings.documentsType).map((type) => {
		const optional = type[0] === 'powerOfSignature' || type[0] === 'idCardSignatory';
		const missing = !optional && !documents.some(f => f.value === type[0]);

		if (missing)
			findMissing = true;

		return ({
			value:  type[0],
			render: <>
				{`${type[1]} ${optional ? `(${TEXTE.global.optional})` : ''}`}
				{missing && <Icon icon={img_alert} />}
			</>
		});
	});
	const MENU_DATA: TabsData[] = [
		{value: 'account', render: TEXTE.settings.myAccount},
		{value: 'identification', render: TEXTE.settings.identification},
		{
			value:  'company',
			right:  'company.edit',
			render: (
				<>
					{TEXTE.settings.myCompany}
					{findMissing && <Icon icon={img_alert} />}
				</>
			)
		},
		{value: 'address', render: TEXTE.settings.address, right: 'company.edit'}
	];

	useEffect(getDocuments, []);

	useEffect(() => {
		set_change(checkChange());
	}, [firstname, lastname, email, phone, contractStart, contractEnd, job, profilePictureFile,
		password, newPassword, newPasswordConfirm, load]);

	useEffect(() => {
		const view = window.location.pathname;

		if ((view === '/settings' || view.endsWith('account')) && user) {
			set_firstname(user.firstname || '');
			set_lastname(user.lastname || '');
			set_email(user.email || '');
			set_phone(user.phone || '');
			set_contractStart(user.contractStart ? moment(user.contractStart).format('DD/MM/YYYY') : '');
			set_contractEnd(user.contractEnd ? moment(user.contractEnd).format('DD/MM/YYYY') : '');
			set_job(user.job || '');
			set_change(false);
		}
		if (view.endsWith('identification') && user) {
			set_email(user.email || '');
			set_password('');
			set_newPassword('');
			set_newPasswordConfirm('');
		}
		if (view.endsWith('company') && company && address) {
			set_name(company.name || '');
			set_siret(company.siret || '');
			set_phone(company.phone || '');
			set_firstname('');
			set_lastname('');

			const findMainAddress = address.find(find => find.main);
			const findMainBillingAddress = address.find(find => find.billingMain);
			set_mainAddress(findMainAddress ? ft_formatAddressInline(findMainAddress) : '');
			set_mainBillingAddress(findMainBillingAddress ? ft_formatAddressInline(findMainBillingAddress) : '');
		}
	}, [window.location.pathname, user, company, address]);

	function getDocuments() {
		API.getCompanyDocuments(user)
		.then((response) => {
			if (!response || !response.status)
				return set_documents([]);
			set_documents(response.data);
		});
	}

	function checkChange() {
		const view = window.location.pathname;

		if ((view === '/settings' || view.endsWith('account')) && user) {
			if (!user || !firstname || !lastname || !phone || !job)
				return false;
			if (firstname !== user.firstname || lastname !== user.lastname)
				return true;
			if (phone !== user.phone || job !== user.job)
				return true;
			if (contractStart !== (user.contractStart ? moment(user.contractStart).format('DD/MM/YYYY') : ''))
				return true;
			if (contractEnd !== (user.contractEnd ? moment(user.contractEnd).format('DD/MM/YYYY') : ''))
				return true;
			return !!profilePictureFile;
		}
		if (view.endsWith('identification')) {
			if (!password || !newPassword || !newPasswordConfirm || newPassword !== newPasswordConfirm)
				return false;
			if (!regex_password.test(newPassword as string))
				return false;
			return true;
		}
		if (view.endsWith('company') && company)
			return phone !== company.phone;

		return false;
	}

	function editUserAccount() {
		if (!checkChange())
			return;

		set_load(true);

		const apiData: PutUserData = {
			job,
			phone,
			lastname,
			firstname,
			email:         '',
			contractEnd:   contractEnd ? moment(contractEnd, 'DD/MM/YYYY').toDate() : undefined,
			contractStart: contractStart ? moment(contractStart, 'DD/MM/YYYY').toDate() : undefined
		};

		// --- Put User
		dispatch(putCompanyUsersApi({data: apiData, idUser: user?._id, user}))
		.then(async (response) => {
			if (!response?.payload?._id)
				return set_load(false);

			dispatch(changeUserSettings(response.payload));

			const notificationData = ft_genNotification(TEXTE, 'editSettingsSuccess', img_settings);
			ft_pushNotification(dispatch, notificationId, notificationData);

			// --- Upload Profile Picture
			if (profilePictureFile) {
				dispatch(uploadProfilePictureApi({
					user,
					file:   profilePictureFile,
					idUser: response.payload._id
				}))
				.then((responseProfilePicture) => {
					if (responseProfilePicture?.payload)
						dispatch(changeUserProfilePicture(responseProfilePicture.payload.profilePicture));
				});
			}

			set_load(false);
		});
	}

	function editCompany() {
		if (!checkChange() || !company)
			return;

		set_load(true);

		const apiData: PutCompanyData = {phone};

		dispatch(putCompanyApi({data: apiData, idCompany: company._id, user}))
		.then(async (response) => {
			if (!response?.payload?._id)
				return set_load(false);

			const notificationData = ft_genNotification(TEXTE, 'editSettingsSuccess', img_settings);
			ft_pushNotification(dispatch, notificationId, notificationData);

			set_load(false);
		});
	}

	function editUserPassword() {
		if (!checkChange())
			return;

		set_load(true);

		API.putUserPassword({password: password as string, newPassword: newPassword as string}, user)
		.then((response) => {
			let notificationData;

			if (response.error === 'wrong password')
				notificationData = ft_genNotification(TEXTE, 'editPasswordError', img_settings, undefined, 'error');
			else if (response.error)
				notificationData = ft_genNotification(TEXTE, 'error', img_settings, response.error, 'error');
			else {
				notificationData = ft_genNotification(TEXTE, 'editPasswordSuccess', img_settings);

				set_password('');
				set_newPassword('');
				set_newPasswordConfirm('');
			}
			ft_pushNotification(dispatch, notificationId, notificationData);

			set_load(false);
		});
	}

	function uploadFile(file?: File) {
		if (!file)
			return;

		let error = null;

		if (file.size > 2097152)
			error = TEXTE.global.fileToBig;

		if (!error) {
			if (documentsView.startsWith('idCard') && (!firstname || !lastname))
				return set_modalUpload(file);
			if (documentsView === 'companyBalance' && !documentDate)
				return set_modalUpload(file);
		}

		const index = documentsUpload.length;
		const dispatchData = {
			index,
			dispatch,
			function: setUploadPercent
		};
		const uploadFileData = {
			filename: file.name,
			size:     file.size,
			percent:  error || 0,
			id:       `${documentsView}${new Date()}`
		};

		dispatch(pushUpload(uploadFileData));

		if (!error) {
			let data;

			if (documentsView.startsWith('idCard'))
				data = {firstname, lastname};
			if (documentsView.startsWith('companyBalance'))
				data = {documentDate: moment(documentDate, 'DD/MM/YYYY').toDate()};

			API.uploadCompanyDocument(documentsView, file, user, dispatchData, data)
			.then((response) => {
				if (!response || !response.status)
					return dispatch(setUploadPercent({index, percent: `error: ${response?.error || ''}`}));

				const notification = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, TEXTE.settings.documentsType[documentsView]);

				ft_pushNotification(dispatch, notificationId, notification);
				set_modalUpload(null);
				set_firstname('');
				set_lastname('');
				set_documentDate('');
				getDocuments();
			});
		}
	}

	function initMFA() {
		set_load(true);

		API.initMFA(user)
		.then((response) => {
			set_load(false);

			if (!response?.data?.secret)
				return ft_pushNotification(dispatch, notificationId, ft_genNotification(TEXTE, 'error', img_settings, response?.error, 'error'));
			set_mfaSecret(response.data.secret);
		});
	}

	function validateMFA() {
		set_load(true);

		API.validateMFA(mfaKey as string, user)
		.then((response) => {
			set_load(false);

			if (!response?.data)
				return ft_pushNotification(dispatch, notificationId, ft_genNotification(TEXTE, 'error', img_settings, response?.error, 'error'));

			ft_pushNotification(dispatch, notificationId, ft_genNotification(TEXTE, 'activeMFASuccess', img_settings));
			dispatch(setUserMFA());
		});
	}

	function renderMyAccount() {
		return (
			<div className={'globalDataContainer'}>
				<div className={'globalDataContainerItem column'}>
					<MultiInputContainer>
						<Input
							required
							value={firstname}
							onChange={set_firstname}
							title={TEXTE.global.firstname}
						/>
						<Input
							required
							value={lastname}
							onChange={set_lastname}
							title={TEXTE.global.lastname}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Input
							readOnly
							required
							value={email}
							title={TEXTE.global.email}
						/>
						<Input
							required
							value={phone}
							onChange={set_phone}
							title={TEXTE.global.phone}
						/>
					</MultiInputContainer>

					<Input
						required
						value={job}
						onChange={set_job}
						title={TEXTE.global.job}
					/>

					<ProfilePicture
						user={user}
						profilePictureImg={profilePictureImg}
						profilePictureFile={profilePictureFile}
						setProfilePictureImg={set_profilePictureImg}
						setProfilePictureFile={set_profilePictureFile}
					/>
				</div>

				<ButtonStickyContainer>
					<Button
						fullWidth
						isLoad={load}
						disabled={!change}
						onClick={editUserAccount}
					>
						{TEXTE.global.saveChange}
					</Button>
				</ButtonStickyContainer>
			</div>
		);
	}

	function renderIdentification() {
		return (
			<div className={'globalDataContainer'}>
				<div className={'globalDataContainerItem column'}>
					<MultiInputContainer>
						<Input
							required
							readOnly
							value={email}
							title={TEXTE.global.email}
						/>
						<Input
							type={'password'}
							value={password}
							onChange={set_password}
							title={TEXTE.settings.actualPassword}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Input
							type={'password'}
							value={newPassword}
							onChange={set_newPassword}
							title={TEXTE.settings.newPassword}
							error={!!(newPassword && !regex_password.test(newPassword as string))}
						>
							<div className={'settingsPasswordRules'}>
								<span>{TEXTE.settings.passwordRules.text}</span>
								{TEXTE.settings.passwordRules.rules.map((e, i) => <span key={`rules-${i}`}>{e}</span>)}
							</div>
						</Input>
						<Input
							type={'password'}
							value={newPasswordConfirm}
							onChange={set_newPasswordConfirm}
							title={TEXTE.settings.confirmPassword}
							error={!!((newPassword || newPasswordConfirm) && newPassword !== newPasswordConfirm)}
						>
							{TEXTE.settings.mustBeIdentical}
						</Input>
					</MultiInputContainer>
					<Button
						fullWidth
						isLoad={load}
						disabled={!change}
						onClick={editUserPassword}
					>
						{TEXTE.global.saveChange}
					</Button>
				</div>

				<br />
				<div className={'globalDataContainerItem column'}>
					<span className="gray-700 text-lg weight-600">{TEXTE.settings.mfa}</span>

					{user?.data?.mfa ?
						<Badge
							size={'lg'}
							color={'success'}
							text={TEXTE.settings.config}
						/>
						:
						<>
							{!mfaSecret ?
								<>
									<span className="gray-600">{TEXTE.settings.mfaText}</span>
									<Button
										size={'sm'}
										isLoad={load}
										onClick={initMFA}
									>
										{TEXTE.settings.mfaAdd}
									</Button>
								</>
								:
								<>
									<span className="gray-600 weight-600">{TEXTE.settings.mfaScan}</span>
									<QRCodeSVG
										size={200}
										value={`otpauth://totp/MyValala:${user?.email}?secret=${mfaSecret}&issuer=MyValala`}
									/>

									<br />
									<Input
										title={TEXTE.settings.mfaInput}
										value={mfaKey}
										onChange={val => set_mfaKey((val as string || '').replace(/[^0-9]/gi, '').slice(0, 6))}
									/>

									<Button
										size={'sm'}
										isLoad={load}
										onClick={validateMFA}
										disabled={(mfaKey as string || '').length !== 6}
									>
										{TEXTE.settings.mfaValidate}
									</Button>
								</>
							}
						</>
					}
				</div>
			</div>
		);
	}

	function renderDocument() {
		const render: React.ReactElement[] = [];

		documents.forEach((document) => {
			if (document.value !== documentsView)
				return;

			const onClickDelete = () => {
				if (!company?._id)
					return;

				API.deleteCompanyDocument(company._id, document, user)
				.then((response) => {
					const notification = ft_genNotification(TEXTE, (!response || !response.status) ? 'error' : 'editSuccess', img_trash, response.error, (!response || !response.status) ? 'error' : 'success');

					ft_pushNotification(dispatch, notificationId, notification);
					getDocuments();
				});
			};

			render.push(
				<DocumentItem
					size={document.size}
					filename={document.name}
					isValala={document.isValala}
					onClickDelete={onClickDelete}
					creator={ft_getDocumentCreator(document, users)}
					onClick={async () => {
						if (!company?._id)
							return;

						const url = await API.downloadCompanyDocument(company?._id, document, user, true);

						set_modalDocument({url: url as string, document});
					}}
					onClickDownload={() => company && API.downloadCompanyDocument(company._id, document, user, true)}
				/>
			);
		});

		return (
			<div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
				{render}

				<Input
					type={'file'}
					onChangeFile={f => uploadFile(f?.[0])}
					fileInputText={TEXTE.devices.deviceDocumentRules}
					accept={'gif,.jpg,.jpeg,.tiff,.png,.webp,.bmp,.pdf'}
				/>

				{modalDocument &&
					<Modal
						fullWidth
						onClose={() => set_modalDocument(null)}
						confirmButtonText={TEXTE.global.download}
						confirmButton={() => API.downloadCompanyDocument(company?._id || '', modalDocument.document, user)}
					>
						<embed src={modalDocument.url} style={{width: '100%', height: '90vh'}} />
					</Modal>
				}

				{modalUpload &&
					<Modal
						gap={16}
						onClose={() => set_modalUpload(null)}
						confirmButtonText={TEXTE.settings.upload}
						header={documentsView === 'companyBalance' ? TEXTE.settings.documentDate : TEXTE.settings.idCardData}
						confirmButton={(documentDate || (firstname && lastname)) ? () => uploadFile(modalUpload) : undefined}
					>
						{documentsView === 'companyBalance' ?
							<Input
								required
								type={'date'}
								value={documentDate}
								placeholder={'JJ/MM/AAAA'}
								onChange={set_documentDate}
								style={{marginBottom: 300}}
							/>
							:
							<>
								<Input
									required
									value={firstname}
									onChange={set_firstname}
									title={TEXTE.global.firstname}
								/>
								<Input
									required
									value={lastname}
									onChange={set_lastname}
									title={TEXTE.global.lastname}
								/>
							</>
						}
					</Modal>
				}
			</div>
		);
	}

	function renderCompany() {
		return (
			<div className={'globalDataContainer'}>
				<div className={'globalDataContainerItem column'}>
					<MultiInputContainer>
						<Input
							readOnly
							value={name}
							title={TEXTE.settings.companyName}
						/>
						<Input
							readOnly
							value={siret}
							title={TEXTE.settings.siret}
						/>
					</MultiInputContainer>

					<Input
						value={phone}
						onChange={set_phone}
						title={TEXTE.global.phone}
					/>

					<MultiInputContainer>
						<Select
							value={1}
							onChange={() => null}
							onClick={() => set_modal('main')}
							title={TEXTE.settings.mainAddress}
							data={[{value: 1, render: mainAddress}]}
						/>
						<Select
							value={1}
							onChange={() => null}
							onClick={() => set_modal('mainBilling')}
							title={TEXTE.settings.billingAddress}
							data={[{value: 1, render: mainBillingAddress}]}
						/>
					</MultiInputContainer>
				</div>

				<br />
				<div className={'globalDataContainerItem column'}>
					<span className={'text-lg weight-600 gray-900'}>{TEXTE.settings.documents}</span>

					<Tabs
						button
						alignLeft
						data={DOCUMENTS_MENU}
						actual={documentsView}
						onChange={val => set_documentsView(val as keyof LanguageType['settings']['documentsType'])}
					/>

					{renderDocument()}
				</div>

				<ButtonStickyContainer>
					<Button
						fullWidth
						isLoad={load}
						disabled={!change}
						onClick={editCompany}
					>
						{TEXTE.global.saveChange}
					</Button>
				</ButtonStickyContainer>
			</div>
		);
	}

	return (
		<div className={'globalContainerWithHeader'}>
			<Header
				menu={MENU_DATA}
				menuValue={params['*']}
				title={TEXTE.settings.title}
			/>

			<Routes>
				<Route path={'/'} element={renderMyAccount()} />
				<Route path={'/account'} element={renderMyAccount()} />
				<Route path={'/identification'} element={renderIdentification()} />
				{ft_checkRight(user, 'company.edit') && <Route path={'/company'} element={renderCompany()} />}
				{ft_checkRight(user, 'company.edit') &&
					<Route path={'/address'} element={<SettingsAddress isBilling={addressMenu !== 'main'} setMenu={set_addressMenu} />} />
				}
			</Routes>

			{modal &&
				<SettingsAddress
					modal
					onClose={() => set_modal(false)}
					isBilling={modal === 'mainBilling'}
				/>
			}
		</div>
	);
}

export default Settings;
